import { TextField } from '@mui/material';
import StyledFormControl from '../StyledComponents/StyledFormControl';

const StyledTextfield = ({
  id,
  type = 'int',
  value,
  minValue = Number.MIN_VALUE,
  maxValue = Number.MAX_VALUE,
  setValue,
  myWidth,
  isDisabled,
  disabledcolor
}) => {
  const onChangeHandler = (event) => {
    const regex = type === 'int' ? new RegExp('^[0-9]*$') : new RegExp('^[0-9|.|,]*$');

    if (event.target.value.toString().length === 0) {
      setValue('');
      return;
    }

    if ((type !== 'int' && event.target.value.toString().slice(-1) === '.') || (type !== 'int' && event.target.value.toString().slice(-1) === ',')) {
      setValue(event.target.value);
      return;
    }

    if (!regex.test(event.target.value)) {
      setValue(value);
      return;
    }

    const parsedValue = type === 'int' ? parseInt(event.target.value) : parseFloat(event.target.value.replace(',', '.'), 10);

    if (parsedValue > maxValue) {
      setValue(maxValue);
    } else if (parsedValue < minValue) {
      setValue(minValue);
    } else {
      setValue(parsedValue);
    }
  };
  return (
    <StyledFormControl disabledcolor={disabledcolor} style={{ width: myWidth ? myWidth : '100%' }}>
      <TextField
        autoComplete="off"
        variant="outlined"
        id={id}
        type="number"
        inputProps={{
          min: minValue,
          max: maxValue,
          style: { textAlign: 'center', width: '100%' }
        }}
        value={value}
        onChange={onChangeHandler}
        disabled={isDisabled}
      />
    </StyledFormControl>
  );
};

export default StyledTextfield;
